// frontend/src/pages/employees/StatTiles.jsx
import React from "react";
import { hours as fmtHours } from "./format";

const row = {
  display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
  gap: 16, marginBottom: 8,
};
const tile = {
  background: "white", borderRadius: 12, padding: 20,
  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
};
const heading = {
  fontSize: 12, fontWeight: 600, color: "#6b7280", marginBottom: 8,
  textTransform: "uppercase", letterSpacing: 0.4,
};

/**
 * Two numbers, both measuring the selected period.
 *
 * Vacation and stat deliberately do NOT appear here. They cannot: hours
 * are a sum over the period, but vacation accrues over each employee's
 * hire anniversary year and is only readable as at a date, and stat is
 * credited per holiday. Four big numbers in an identical row assert that
 * they are comparable, and two of those would not be -- so they live in
 * LeavePanel under a caption naming their own window instead. See the
 * spec, section 4 and decision 8.
 */
export default function StatTiles({ hours, billableHours, caption }) {
  return (
    <div style={{ marginBottom: 24 }}>
      <div style={row}>
        <div style={tile}>
          <div style={heading}>Hours</div>
          <div style={{ fontSize: 28, fontWeight: 700, color: "#111827" }}>
            {fmtHours(hours)}
          </div>
        </div>
        <div style={tile}>
          <div style={heading}>Billable</div>
          <div style={{ fontSize: 28, fontWeight: 700, color: "#10b981" }}>
            {fmtHours(billableHours)}
          </div>
        </div>
      </div>
      {caption && (
        <div style={{ fontSize: 12, color: "#6b7280", marginTop: 8 }}>
          {caption}
        </div>
      )}
    </div>
  );
}
